import { replace } from 'ramda';

export const capitalize = (s: string): string => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export const toTitleCase = (s: string): string => s
  .split(' ')
  .filter(Boolean)
  .map(capitalize)
  .join(' ');

export const compareAlphaNum = (stopeNameA: string, stopeNameB: string): number => {
  const nameA = (stopeNameA ?? '').toUpperCase();
  const nameB = (stopeNameB ?? '').toUpperCase();
  return nameA.localeCompare(nameB, 'en', { numeric: true });
};

export const resolveTemplate = (template: string, variables: { [key: string]: string | number }) => Object.keys(variables)
  .reduce((accResolvedTemplate, variableKey) => replace(
    `${variableKey}`,
    `${variables[variableKey]}`,
    accResolvedTemplate,
  ), template);

export const splitCaps = (currentString: string) => currentString.replace(/([A-Z])/g, ' $1').trim();

export const isNumeric = (str: string) => !Number.isNaN(str) // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
  && !Number.isNaN(Number(str)); // ...and ensure strings of whitespace fail
